export const clearAppSessionStorage = (): void => {
  window.sessionStorage.removeItem('access-token');
  window.sessionStorage.removeItem('local-access-token');
  window.sessionStorage.removeItem('deIdentified');
};

export const clearLegacyAppLocalStorage = (): void => {
  window.localStorage.removeItem('okta-token-storage');
  window.localStorage.removeItem('access-token');
  window.localStorage.removeItem('deIdentified');
};
